import { render, staticRenderFns } from "./DateDistributionChart.vue?vue&type=template&id=fc67aa8e"
import script from "./DateDistributionChart.vue?vue&type=script&lang=js"
export * from "./DateDistributionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc67aa8e')) {
      api.createRecord('fc67aa8e', component.options)
    } else {
      api.reload('fc67aa8e', component.options)
    }
    module.hot.accept("./DateDistributionChart.vue?vue&type=template&id=fc67aa8e", function () {
      api.rerender('fc67aa8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/DateDistributionChart.vue"
export default component.exports